module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0107.0d130d9a.jpg";